// src/pages/UserAssistantPage.jsx

import { fetchUserAssistantInsight } from "../Gemini/userAssistantService";

/**
 * =====================================================
 * UserAssistantPage
 * -----------------------------------------------------
 * Controller / Adapter for the "user_assistant" model
 *
 * Responsibilities:
 * 1. Accept raw user prompt
 * 2. Call user_assistant backend API
 * 3. Normalize response into UI-friendly format
 * 4. Return a unified result object to PromptPage
 * =====================================================
 */

/**
 * Normalize API response so existing tables can render it
 */
const normalizeUserAssistantData = (dataSummary) => {
  if (!dataSummary) return [];

  return [
    {
      period_type: "current",
      impressions: "-",
      clicks: dataSummary.total_clicks ?? 0,
      ctr: "-",
      cost: dataSummary.total_cost ?? 0,
      conversions: "-",
      date_range: dataSummary.date_range,
    },
  ];
};

/**
 * Main handler used by PromptPage.jsx
 */
export const handleUserAssistantPrompt = async (prompt) => {
  const result = await fetchUserAssistantInsight(prompt);

  // If API failed
  if (!result) {
    return {
      type: "text",
      content: "No response from user assistant.",
    };
  }

  // ✅ Always show the natural language answer
  if (result.type === "text" && !result.data) {
    return result;
  }

  // ✅ If structured data exists, return BOTH text + meta
  if (result.type === "data_viz") {
    return {
      type: "text",
      content: result.answer, // <-- MAIN CHAT ANSWER
      meta: {
        total_cost: result.data.total_cost,
        total_clicks: result.data.total_clicks,
        date_range: result.data.date_range,
        model: "user_assistant",
      },
    };
  }

  return {
    type: "text",
    content: "No valid response from user assistant.",
  };
};


export default handleUserAssistantPrompt;
